import * as XLSX from "xlsx";

function readExcelFileContent(file: File): Promise<Record<string, any[]>> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      if (!e || !e.target) return;
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetsData: Record<string, any[]> = {};

      // Iterate over all sheets
      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        let jsonData = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: false,
        });

        // Filter out empty rows
        jsonData = jsonData.filter((row: any) =>
          row.some(
            (cell: any) => cell !== null && cell !== undefined && cell !== ""
          )
        );

        // Store the data with the sheet name as the key
        sheetsData[sheetName] = jsonData;
      });

      resolve(sheetsData);
    };

    reader.onerror = () => {
      reject(reader.error);
    };

    reader.readAsBinaryString(file);
  });
}

export const excelParser = async (
  formData: FormData
): Promise<Record<string, any[]>> => {
  // Check if the file exists

  const file = formData.get("formFile") as File;
  if (file) {
    // Read and return the content of the file
    return await readExcelFileContent(file);
  } else {
    // If file does not exist, return an error message or handle the situation accordingly
    throw new Error("File not found in FormData.");
  }
};

export function createExcelFormData(
  data: string[][],
  fileName: string,
  sheetName: string
): FormData {
  // Create a worksheet from the array of string arrays
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Generate the Excel file as binary string
  const excelBinary = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "binary",
  });

  // Convert the binary string to a Blob
  const buffer = new ArrayBuffer(excelBinary.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < excelBinary.length; i++) {
    view[i] = excelBinary.charCodeAt(i) & 0xff;
  }
  const excelBlob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create FormData and append the Blob as a file
  const formData = new FormData();
  formData.append("formFile", excelBlob, fileName);

  return formData;
}
